import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-image-with-effects-form",
  templateUrl: "./product-image-with-effects-form.component.html",
  styleUrls: ["./product-image-with-effects-form.component.scss"],
})
export class ProductImageWithEffectsFormComponent {
  @Input() form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-image-with-effects-form/product-image-with-effects-form.component.ts